import {TreeNode} from "antd/es/tree-select";
import {TreeSelect} from "antd";
import React, {useEffect, useState} from "react";
import axios from "../common/axios";
import {COMPARISON_TYPE} from "./Styles";

const TreeSelectFilter = ({syllabus = null, setValues, testIds, triggerGenerate, comparisonContentTypeVal, disabled, diagnosticContentType})=>{

    const {SHOW_PARENT} = TreeSelect;

    const [treeData, setTreeData] = useState([]),
        [tempValues, setTempValues] = useState([]),
        [selected, setSelected] = useState(),
        [contentKeys, setContentKeys] = useState({});

    // For Diagnostic Reports
    if(syllabus !== null){
        useEffect(()=>{
            if(syllabus === null || Object.keys(syllabus).length === 0){
                return;
            }
            let treeDataMap = {};
            // syllabuses.forEach((syllabus,idx) =>{
            const syllabusKey = String(syllabus.syllabusId);
            // console.log('syllabus: ',syllabus);
            const syllabusChildren = [];
            treeDataMap[syllabus.syllabusId] = {key:syllabusKey, value:syllabusKey, title:syllabus.syllabusName, label:syllabus.syllabusName};
            axios.get('/web/ui/nav/syllabus/' + syllabus.syllabusId + '/topics')
                .then(response => {
                    if (response.data) {
                        // console.log(response.data);
                        response.data.forEach(topic =>{
                            const topicKey = syllabusKey+'-'+String(topic.topicId);
                            const topicChildren = [];
                            topic.concepts.forEach(concept =>{
                                const conceptKey = topicKey+'-'+String(concept.conceptId);
                                topicChildren.push({key:conceptKey, value: conceptKey, title: concept.conceptName, label: concept.conceptName})
                            });
                            syllabusChildren.push({key:topicKey, value:topicKey, title: topic.topicName, label: topic.topicName, children: topicChildren});
                        });
                        treeDataMap[syllabus.syllabusId].children = syllabusChildren;
                        // if(idx === syllabuses.length-1){
                        setTreeData(Object.values(treeDataMap));
                        // }
                    }
                }).catch(error=>{
                console.error('Error loading topics in TreeSelectFilter. ',error);
                // });
            });
        },[syllabus]);

        useEffect(()=>{
            if(testIds.length === 0){
                return;
            }

            let treeDataMap = {};
            // syllabuses.forEach((syllabus,idx) =>{
            const syllabusKey = String(syllabus.syllabusId);
            // console.log('syllabus: ',syllabus);
            const syllabusChildren = [];
            treeDataMap[syllabus.syllabusId] = {key:syllabusKey, value:syllabusKey, title:syllabus.syllabusName, label:syllabus.syllabusName};

            axios.get('/web/ui/test/conceptsInTests',{params: {testIds:testIds.toString(), syllabusId:syllabus.syllabusId}})
                .then(response=>{
                    const conceptKeys = [],
                        topicKeys = [],
                        syllabusKeys = [];
                    response.data.forEach(concept=>{
                        syllabusKeys.push(concept.syllabusId+'');
                        topicKeys.push(concept.syllabusId+'-'+concept.topicId);
                        conceptKeys.push(concept.syllabusId+'-'+concept.topicId+'-'+concept.conceptId);
                    });
                    setContentKeys({syllabusKeys:syllabusKeys, topicKeys:topicKeys, conceptKeys:conceptKeys});
                    setValues(conceptKeys);
                    setSelected(conceptKeys);
                    setTempValues(conceptKeys);

                }).catch(error=>{
                console.error('Error loading concepts in tests. ',error);
            });

        },[testIds, treeData, comparisonContentTypeVal]);
    }else{
        // For Test Group Reports
        useEffect(()=>{
                axios.get('/web/ui/test/conceptsInTests',{params:{testIds:testIds.toString(), syllabusType:diagnosticContentType}})
                    .then(response=>{

                        const syllabusKeys = [],
                            conceptKeys = [],
                            topicKeys = [],
                            syllabuses = {},
                            topics = {},
                            concepts = {};

                        let syllabusKey,
                            topicKey,
                            conceptKey;

                        response.data.forEach(concept=>{
                            // if((COMPARISON_TYPE.TEXT.val === comparisonContentTypeVal && !concept.curriculumConcept) || (COMPARISON_TYPE.CURRICULUM.val === comparisonContentTypeVal && concept.curriculumConcept)){
                                syllabusKey = comparisonContentTypeVal+'-'+concept.syllabusId+'';
                                topicKey = comparisonContentTypeVal+'-'+concept.syllabusId+'-'+concept.topicId;
                                conceptKey = comparisonContentTypeVal+'-'+concept.syllabusId+'-'+concept.topicId+'-'+concept.conceptId;

                                syllabusKeys.push(syllabusKey);
                                topicKeys.push(topicKey);
                                conceptKeys.push(conceptKey);

                                let syllabus,
                                    topic,
                                    newConcept;

                                if(!syllabuses.hasOwnProperty(concept.syllabusId)){
                                    syllabus = {key:syllabusKey, value: syllabusKey, title: concept.syllabusName, label: concept.syllabusName, children:[]};
                                    syllabuses[concept.syllabusId] = syllabus;
                                }else{
                                    syllabus = syllabuses[concept.syllabusId];
                                }

                                if(!topics.hasOwnProperty(concept.topicId)){
                                    topic = {key:topicKey, value: topicKey, title: concept.topicName, label: concept.topicName, children:[]};
                                    topics[concept.topicId] = topic;
                                    syllabus.children.push(topic);
                                }else{
                                    topic = topics[concept.topicId];
                                }

                                if(!concepts.hasOwnProperty(concept.conceptId)){
                                    newConcept = {key:conceptKey, value: conceptKey, title: concept.conceptName, label: concept.conceptName, children:[]};
                                    concepts[concept.conceptId] = newConcept;
                                    topic.children.push(newConcept);
                                }
                            // }
                        });

                        setTreeData(Object.values(syllabuses));

                        setContentKeys({syllabusKeys:syllabusKeys, topicKeys:topicKeys, conceptKeys:conceptKeys});
                        setValues(conceptKeys);
                        setSelected(conceptKeys);
                        setTempValues(conceptKeys);
                    }).catch(error=>{
                    console.error('Error loading concepts in tests. ',error);
                });
        },[triggerGenerate]);
    }


    const treeSelectOnBlur = () =>{
        setValues(tempValues);
    }

    const treeSelectOnChange = value =>{
        setTempValues(value);
        setSelected(value);
    }

    const treeSelectOnClear = () =>{
        setValues([]);
    }

    return(
        <TreeSelect
                    disabled={disabled}
                    treeNodeFilterProp="title" allowClear={true}
                    removeIcon={null}
                    onBlur={treeSelectOnBlur} onChange={treeSelectOnChange}
                    onClear={treeSelectOnClear}
                    showCheckedStrategy={SHOW_PARENT}
                    maxTagCount="responsive"
                    value={selected}
                    treeCheckable={true} multiple={true} style={{width:'100%'}}
                    getPopupContainer={trigger => trigger.parentElement}
        >
            {Object.keys(contentKeys).length > 0 && treeData.length > 0 &&  treeData?.map((syllabus,idx)=>{
                return (
                    <TreeNode key={syllabus.key} value={syllabus.value} title={syllabus.title} label={syllabus.label}
                              disabled={!contentKeys.syllabusKeys.includes(syllabus.value)}
                    >
                        {syllabus.children?.map(topic=>{
                            return (
                                <TreeNode key={topic.key} value={topic.value} title={topic.title} label={topic.label}
                                          disabled={!contentKeys.topicKeys.includes(topic.value)}
                                >
                                    {topic.children?.map(concept=>{
                                        return <TreeNode key={concept.key} value={concept.value} title={concept.title} label={concept.label}
                                                         disabled={!contentKeys.conceptKeys.includes(concept.value)}
                                        />
                                    })}
                                </TreeNode>
                            )
                        })}
                    </TreeNode>
                )
            })}
        </TreeSelect>
    )
}
export default TreeSelectFilter;
